/* tslint:disable no-bitwise */
import { Envelope, publish, subscribe, unsubscribe } from '@wh/message-bus';

// @ts-ignore
type JSON = null | string | number | boolean | Record<string, JSON> | JSON[];
type SubscribeCallback = (data: any, id?: JSON) => void;

let requestCounter: number = 0;

export function generateMessageId(): string {
  requestCounter = (requestCounter + 1) & 0xfff;
  const requestId = (((Date.now() & 0x7ffff) << 12) | requestCounter).toString(16);
  return requestId;
}

export function publishMessage(topic: string, data: any, id?: string): boolean {
  const headers = id ? { correlationId: id } : undefined;
  return publish({ topic, data, headers });
}

export function subscribeToMessage(topic: string, callback: SubscribeCallback, requestId?: string): string {
  return subscribe({
    topic,
    callback: (message: Envelope) => {
      const { data, headers } = message;
      if ((!requestId || requestId === headers.correlationId)) {
        callback(data || {}, headers.correlationId);
      }
    },
  });
}

export function unsubscribeFromMessage(id: string): void {
  unsubscribe(id);
}
